import { AfterViewInit, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import {
  AccountService,
  AlertService,
  CampaignProductService,
  CampaignService,
  CampaignTrackingService,
  CRMCampaignService,
  FunnelStepService,
  GatewayTransactionReportService,
  MerchantService,
  ReportsConfigService,
  StorageService,
  UserService,
  CancelReasonCategoryService
} from '../_services';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { ReportsAbstractV2Component } from './reports-abstract-v2.component';
import { MultiOptions } from '../custom-multi-select/multi-select';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { cloneDeep } from 'lodash';
import { ReportTypes } from './models/reports';
import { GatewayTransactionFields, GatewayTransactionFilters } from './utils/constants';

@Component({
  moduleId: module.id.toString(),
  selector: 'gateway-transaction-report-v2',
  templateUrl: './templates/reports-v2.component.html',
  styleUrls: ['./styles/reports-v2.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class GatewayTransactionReportV2Component extends ReportsAbstractV2Component implements OnInit, AfterViewInit {
  reportTitle = 'Gateway Transaction Report (Beta)';
  fields: MultiOptions = cloneDeep(GatewayTransactionFields);
  filters: MultiOptions = cloneDeep(GatewayTransactionFilters);
  reportType = ReportTypes.GATEWAY_TRANSACTION;
  dropdownsLoading: boolean = false;

  predefinedFields = ['exclude_zeroes'];
  commonReportsFields = [];
  summaryFields = [];
  selectedDimensions = [
    {
      model: 'transaction_attempted_date',
      label: 'Txn Date',
      selected: true,
      disabled: false,
    },
    {
      model: 'transaction_id',
      label: 'Txn ID',
      selected: true,
      disabled: false,
    },
    {
      model: 'transaction_status',
      label: 'Txn Status',
      selected: true,
      disabled: false,
    },
    {
      model: 'transaction_amount',
      label: 'Txn Amount',
      selected: true,
      disabled: false,
    },
  ];

  constructor(
    protected router: Router,
    protected location: Location,
    protected route: ActivatedRoute,
    protected alertService: AlertService,
    protected formBuilder: FormBuilder,
    public reportsService: GatewayTransactionReportService,
    protected campaignService: CampaignService,
    protected reportsConfigService: ReportsConfigService,
    protected trackingSourceService: CampaignTrackingService,
    protected userService: UserService,
    protected accountService: AccountService,
    protected campaignProductService: CampaignProductService,
    protected crmCampaignService: CRMCampaignService,
    protected storageService: StorageService,
    protected stepService: FunnelStepService,
    protected merchantService: MerchantService,
    protected modalService: NgxSmartModalService,
    protected cancelReasonCategoryService: CancelReasonCategoryService
  ) {
    super(
      router,
      location,
      route,
      alertService,
      reportsService,
      campaignService,
      reportsConfigService,
      trackingSourceService,
      userService,
      accountService,
      campaignProductService,
      crmCampaignService,
      storageService,
      stepService,
      merchantService,
      modalService,
      cancelReasonCategoryService
    );

    this.updatePreSelectedDimensions(['transaction_attempted_date','transaction_id', 'transaction_status', 'transaction_amount']);
    this.filterCommonDimensions(this.commonReportsFields);
  }

  ngOnInit() {
    super.ngOnInit();
    this.isGatewayTransactionReport = true;
  }

  ngAfterViewInit() {
    if (this.panel) {
      this.panel.expanded = false;
    }

    if (this.tablePanel) {
      this.tablePanel.expanded = true;
    }
  }

  drop(event: CdkDragDrop<string[]>): void {
    moveItemInArray(this.selectedDimensions, event.previousIndex, event.currentIndex);
  }
}
